import { render, staticRenderFns } from "./yuyuecheinfo.vue?vue&type=template&id=72125ab1&scoped=true"
import script from "./yuyuecheinfo.vue?vue&type=script&lang=js"
export * from "./yuyuecheinfo.vue?vue&type=script&lang=js"
import style0 from "./yuyuecheinfo.vue?vue&type=style&index=0&id=72125ab1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72125ab1",
  null
  
)

export default component.exports